module.exports = __webpack_public_path__ + "img/pic_wx.79bf9b49.png";